define('lq/licquidRuntimeSpa',[
    'lq',
    'underscore',
    'when',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/parameterShell',
    'lq/actionLoader',
    'lq/navigatorSpa',
    'lq/style',
    'lq/windowSize',
    'lq/responsive',
    'lq/services/application/applicationServiceFactory',
    'lq/validatorGateway',
    'lq/highlighter',
    'lq/layouting',
    'lq/runtimeLocation',
    'lq/javascript/polyfill'
], function (lq, _, when, Action, RuntimePiping, ParameterShell, ActionLoader, NavigatorSpa, Style, windowSize, responsive, applicationServiceFactory, validatorGateway, highlighter, layouting, runtimeLocation) {

    var deferredPrompt = null;
    if (!responsive.isPWA()) {
        // Running in Browser
        window.addEventListener('beforeinstallprompt', function (e) {
            deferredPrompt = e;
        });
    }

    var inIframe = function () {
        return window !== window.parent;
    };

    var LicquidRuntimeSpa = function () { };

    LicquidRuntimeSpa.prototype.start = function (setup) {
        lq.setIsInMockMode(setup.isInMockMode);
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }

        var self = this;
        windowSize.withOnChanged(function () {
            if (self.action) self.action.resize();
        });

        Style.defaultStyles = setup.application.styles.defaultStyles;
        Style.defaultMockStyles = setup.application.styles.defaultMockStyles;
        Style.mockMode = setup.isInMockMode;

        this.action = null;
        // per-instance position baseline (not sessionStorage) so tabs/iframes don't collide
        this.positionLastShown = (window.history.state && window.history.state.position) || 0;
        this.positionCounter = this.positionLastShown;
        // the intercepted back press whose backClicked event may still navigate (see startBackHandling)
        this.backHandling = null;
        // the page a navigation from back handling loaded, waiting for the popstate of its history.back()
        this.pendingBackEntry = null;
        // what the history entry of the shown page holds, to add it again when a back press is intercepted
        this.currentHistoryEntry = null;

        this.$app = setup.$el;
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.$app);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.parameters.globals, setup.application, this.$app);
        this.globalPiping.navigator = NavigatorSpa.withLocalStorage(setup.action.id, this.globalPiping.url, this.openNewAction.bind(this), this.navigationStarting.bind(this));
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));
        this.globalPiping.runtime = this;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'LICQUID_RUNTIME_LOADED',
                globalPiping: this.globalPiping,
                isInMockMode: lq.isInMockMode()
            });
        } else {
            validatorGateway.whenEnabled(function () {
                validatorGateway.publishEvent({
                    type: 'LICQUID_RUNTIME_LOADED',
                    globalPiping: self.globalPiping,
                    isInMockMode: lq.isInMockMode()
                });

                if (self.action !== null) {
                    validatorGateway.registerListener(self.action.instanceId, self.receiveMessage.bind(self));

                    validatorGateway.publishEvent({
                        type: 'ACTION_INSTANCE_LOADED',
                        action: self.action,
                        canReload: false
                    });
                }
            });
        }

        this.globalServices = _.map(setup.application.services, function (service) {
            return applicationServiceFactory.createService(service);
        });
        _.forEach(this.globalServices, function (globalService) {
            globalService.initialize(self);
        });

        this.application = setup.application;

        this.actionLoader = new ActionLoader(this.globalPiping.url);
        this.actionLoader.addListener(this.showAction.bind(this));

        this.globalPiping.busyIndicator.show();
        this.openNewAction(setup.action.id, setup.parameters.globals, setup.parameters.locals);

        this.globalPiping.deferredPrompt = deferredPrompt;
    };

    // back(-1) / reload(0) / forward(+1) from the popped entry's position vs the last shown
    LicquidRuntimeSpa.prototype.reorient = function () {
        var position = history.state ? history.state.position : null;
        if (position == null) {
            position = ++this.positionCounter;
            var s = history.state ?? { position: 0 };
            s.position = position;
            history.replaceState(s, '');
        }
        var direction = Math.sign(position - this.positionLastShown);
        this.positionLastShown = position;
        return direction;
    };

    LicquidRuntimeSpa.prototype.showAction = function (actionId, setup, parameters, state) {
        this.reorient()
        $.extend(this.globalPiping.application, setup.application);

        if(setup.view.insertionPoint) {
            var index = this.insertionPoints.indexOf(setup.view.insertionPoint);
            this.insertionPoints = this.insertionPoints.slice(0, index + 1);
            this.insertionPoints = this.insertionPoints
                .concat(_.map(setup.view.actions, function(action) {
                    return action.action.id;
                }));

            this.action.setContent(setup.view.actions, parameters.locals, setup.view.insertionPoint);

            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            this.insertionPoints = _.map(setup.view.actions, function(action) {
                return action.action.id;
            });

            var actionData = setup.view.actions[0].action;
            var systemParameters = setup.view.actions[0].systemParameters;
            var localParameters = setup.view.actions.length > 1 ? {} : parameters.locals;

            var action = new Action(actionData.view, this.globalPiping.application.options);
            action.loadData(actionData);
            action.piping = this.globalPiping.createChildPiping(actionData, action, localParameters, systemParameters, this.$wrapper, this.$view, !this.action && window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD);
            action.globals = _.clone(parameters.globals);
            action.locals = _.clone(parameters.locals);

            var layout = responsive.getCurrentLayout(action);
            layouting.applyLayout(this.$view, layout);

            var notInsideIFrame = window.top.location === window.location;
            action.applyLayout(layout, notInsideIFrame);

            if (action.shouldUseWidthOfLayout()) {
                action.data.size.x = layout.resolutionX;
            }

            var self = this;
            action.piping.viewTransitionManager.scheduleViewTransition(
                function () {
                    var promise = self.startActionRender(action, setup, parameters);
                    self.postActionRender(action, setup, parameters, state)
                    return promise;
                })
                .then(function () {
                    return action.startEventing();
                })
                .then(function () {
                    return action.setContent(setup.view.actions.slice(1), parameters.locals);
                });
        }

        this.currentActionId = actionId;
    };

    LicquidRuntimeSpa.prototype.startActionRender = function (action, setup, parameters) {
        // todo svb SPA viewport should only be set once (but what with "growable" actions?)
        return action.createAndRenderDrops($('#viewport'));
    };

    LicquidRuntimeSpa.prototype.postActionRender = function (action, setup, parameters, state) {
        if (this.action) {
            if(validatorGateway.isEnabled()) {
                validatorGateway.unregisterListener(this.action.instanceId);

                validatorGateway.publishEvent({
                    type: 'ACTION_INSTANCE_UNLOADING',
                    action: this.action
                });
            }

            this.action.piping.cleanUp();
            this.action.unsubscribeEventHandlersRecursive();

            this.updateHistory(setup, _.last(setup.view.actions).action.id, parameters, state);
        } else {
            this.currentHistoryEntry = {
                state: {
                    actionId: _.last(setup.view.actions).action.id,
                    globals: parameters.globals,
                    locals: parameters.locals,
                    position: this.getPos(),
                    actualUrl: window.location.href
                },
                displayedUrl: this.application.hideUrl ? lq.getTenantUrl('') : window.location.href
            };
            window.history.replaceState(this.currentHistoryEntry.state, '', this.currentHistoryEntry.displayedUrl);
            runtimeLocation.startTracking();
        }

        this.$wrapper.scrollTop(0);
        this.action = action;
        this.action.piping.busyIndicator.forceHide();

        if(validatorGateway.isEnabled()) {
            validatorGateway.registerListener(action.instanceId.toString(), this.receiveMessage.bind(this));
            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_LOADED',
                action: action,
                canReload: setup.view.actions.length === 1
            });
        }

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
        }

        var self = this;
        this.action.subscribeEventHandler($(window), 'popstate', function (ev) {
            var e = ev.originalEvent;
            if (e.state === null) return;

            var positionShown = self.positionLastShown;
            var direction = self.reorient();

            // the history.back() of a navigation from back handling: the page it loaded takes the popped entry's place
            if (self.pendingBackEntry) {
                var pending = self.pendingBackEntry;
                self.pendingBackEntry = null;
                pending.state.position = e.state.position;
                window.history.replaceState(pending.state, '', pending.displayedUrl);
                self.currentHistoryEntry = pending;
                return;
            }
            // reload (0) counts as back
            var movingBack = direction !== 1;

            var chainHasBackClicked = _.some(self.getActionChain(), function (action) {
                return action.getEventDataFor('backClicked').enabled;
            });
            var backHandled = self.application.disableBrowserBackButton || chainHasBackClicked;

            if (movingBack && backHandled) {
                // add the shown page again on top of the popped entry (instead of overwriting it), so the
                // entries behind the user and the length of the history stay as they were
                var entry = self.currentHistoryEntry
                    || self.buildHistoryEntry(setup, self.action.data.id, { locals: self.action.locals, globals: self.action.globals }, positionShown);
                window.history.pushState(entry.state, '', entry.displayedUrl);
                self.positionLastShown = entry.state.position;
                if (self.backHandling) return; // drop overlapping back presses, keep the first one's outcome

                var backHandling = self.startBackHandling();
                self.fireBackClickedUpTheTree().ensure(function () {
                    backHandling.eventRunning = false;
                    // the event only closed something: a later navigation is the user's own
                    if (!backHandling.navigationStarted) self.endBackHandling(backHandling);
                });
                return;
            }

            self.currentHistoryEntry = { state: e.state, displayedUrl: window.location.href };
            self.openNewAction(e.state.actionId, e.state.globals, e.state.locals, { ignoreHistory: true });
        });
    };

    // A back press handled by backClicked stays open until the navigation its event starts is requested, so that
    // navigation ends like a back however long it takes. It ends without one when the event finished and started no
    // navigation, when the user does something else, or after a safety timeout (a navigation that never comes).
    var BACK_HANDLING_TIMEOUT = 15000;

    LicquidRuntimeSpa.prototype.startBackHandling = function () {
        var self = this;
        var backHandling = { eventRunning: true, navigationStarted: false };
        var end = function () { self.endBackHandling(backHandling); };
        backHandling.onInput = function (ev) {
            if (ev.type === 'keydown' && (ev.altKey || ev.metaKey)) return; // keyboard back/forward
            end();
        };
        window.addEventListener('pointerdown', backHandling.onInput, true);
        window.addEventListener('keydown', backHandling.onInput, true);
        backHandling.timeout = setTimeout(end, BACK_HANDLING_TIMEOUT);
        this.backHandling = backHandling;
        return backHandling;
    };

    LicquidRuntimeSpa.prototype.endBackHandling = function (backHandling) {
        if (this.backHandling !== backHandling) return;
        window.removeEventListener('pointerdown', backHandling.onInput, true);
        window.removeEventListener('keydown', backHandling.onInput, true);
        clearTimeout(backHandling.timeout);
        this.backHandling = null;
    };

    // a redirect is about to navigate (it may first update the navigation trail, after its event has finished)
    LicquidRuntimeSpa.prototype.navigationStarting = function () {
        if (this.backHandling && this.backHandling.eventRunning)
            this.backHandling.navigationStarted = true;
    };

    LicquidRuntimeSpa.prototype.updateGlobalParameters = function (newCollection) {
        var globals = this.globalPiping.parameters.globals;
        var newKeys = _.keys(newCollection);
        _.each(newKeys, function (newKey) {
            var newValue = newCollection[newKey];
            if (!globals.parameterExists(newKey) || globals.getValue(newKey) !== newValue)
                globals.setValue(newKey, newValue);
        });
        _.each(_.keys(globals.getAll()), function (key) {
            if (!_.includes(newKeys, key))
                globals.remove(key);
        })
    };

    LicquidRuntimeSpa.prototype.buildHistoryEntry = function (setup, actionId, parameters, position) {
        var pageUrl = setup.friendlyName
            ? setup.friendlyName
            : 'LicquidAction/Get/' + actionId;

        var currentParameters = {};
        if (_.keys(parameters.globals).length)
            currentParameters.globals = JSON.stringify(parameters.globals);
        if (_.keys(parameters.locals).length)
            currentParameters.parameters = JSON.stringify(parameters.locals);

        // actualUrl is where the runtime really is; displayedUrl is what the address bar shows (the tenant root when hideUrl is on)
        var actualUrl = this.globalPiping.url.prepare(lq.getTenantUrl(pageUrl), currentParameters);

        return {
            displayedUrl: this.application.hideUrl ? lq.getTenantUrl('') : actualUrl,
            state: {
                actionId: actionId,
                globals: parameters.globals,
                locals: parameters.locals,
                position: position !== undefined ? position : this.getPos(),
                actualUrl: actualUrl
            }
        };
    };

    LicquidRuntimeSpa.prototype.updateHistory = function (setup, actionId, parameters, state) {
        this.updateGlobalParameters(parameters.globals);
        if (state && state.ignoreHistory) return;

        if (state && state.fromBackHandling) {
            // end like a back: go back to the entry the intercepted back had popped, the popstate puts this page in it
            this.pendingBackEntry = this.buildHistoryEntry(setup, actionId, parameters, null);
            window.history.back();
            return;
        }

        var entry = this.buildHistoryEntry(setup, actionId, parameters);
        window.history.pushState(entry.state, '', entry.displayedUrl);
        this.currentHistoryEntry = entry;
    };

    LicquidRuntimeSpa.prototype.getPos = function () {
        return ++this.positionCounter;
    };

    LicquidRuntimeSpa.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.reloadAction();
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    LicquidRuntimeSpa.prototype.openNewAction = function (actionId, globals, locals, state) {
        if (this.backHandling && !(state && state.ignoreHistory)) {
            // the navigation of a backClicked event: marked on the request, so it doesn't matter when it arrives
            state = _.extend({}, state, { fromBackHandling: true });
            this.endBackHandling(this.backHandling);
        }
        this.actionLoader.load(actionId, globals, locals, state, this.insertionPoints);
    };

    LicquidRuntimeSpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };

    LicquidRuntimeSpa.prototype.reloadAction = function() {
        this.openNewAction(this.currentActionId, this.action.globals, this.action.locals, { ignoreHistory: true });
    };

    LicquidRuntimeSpa.prototype.getActionChain = function () {
        var chain = [];
        var walk = function (action) {
            chain.push(action);
            _.each(action.piping.dropFactory.getAllDrops(), function (drop) {
                if (drop.type === 'ContentRegion' && drop.action)
                    walk(drop.action);
            });
        };
        walk(this.action);
        // deepest action first so backClicked runs children before their parents
        return chain.reverse();
    };

    // await each enabled action's backClicked before the next
    LicquidRuntimeSpa.prototype.fireBackClickedUpTheTree = function () {
        return _.reduce(this.getActionChain(), function (promise, action) {
            return promise.then(function () {
                var eventData = action.getEventDataFor('backClicked');
                if (!eventData.enabled || !action.piping) return;
                var deferred = when.defer();
                action.triggerEvent(eventData.raisedEventName, undefined, undefined, undefined, false, undefined, deferred.resolve, 'backClicked');
                return deferred.promise;
            });
        }, when.resolve());
    };

    return LicquidRuntimeSpa;
});
